export default __webpack_public_path__ + "static/media/sintel.7e244130.ogv";